import React from "react";
import { useNavigate } from "react-router-dom";
import { LuArrowLeft, LuBadgeDollarSign, LuChartNoAxesCombined, LuCircleCheckBig } from "react-icons/lu";
import monthlyPlanBanner from "../assets/zuno/plano_mensalidade_100_ao_motorista.png";
import flexPlanBanner from "../assets/zuno/banner_neon_futurista_do_plano_flex.png";
import { useTheme } from "../theme/ThemeContext";
import { getIOSHomeCampaigns } from "../components/HomePromoCarousel";

const PLAN_CONTENT = {
  mensalidade: {
    name: "Plano Mensalidade",
    image: monthlyPlanBanner,
    alt: "Plano Mensalidade Zuno: 100% da corrida para o motorista",
    kicker: "Mais autonomia para dirigir",
    title: "100% do valor das corridas é seu",
    benefits: [
      [LuBadgeDollarSign, "Receba mais", "Fique com o valor integral das corridas realizadas."],
      [LuChartNoAxesCombined, "Planejamento simples", "Uma mensalidade clara para organizar seus ganhos."],
      [LuCircleCheckBig, "Experiência Zuno", "Acesso ao ecossistema e aos recursos para motoristas."],
    ],
  },
  flex: {
    name: "Plano Flex",
    image: flexPlanBanner,
    alt: "Plano Flex Zuno: somente 8% de comissão por corrida",
    kicker: "Flexibilidade para começar",
    title: "Pague apenas quando fizer corridas",
    benefits: [
      [LuBadgeDollarSign, "Comissão de 8%", "Uma taxa objetiva aplicada somente às corridas realizadas."],
      [LuChartNoAxesCombined, "Sem mensalidade", "Ideal para quem deseja liberdade no ritmo de trabalho."],
      [LuCircleCheckBig, "Experiência Zuno", "Acesso ao ecossistema e aos recursos para motoristas."],
    ],
  },
};

export default function PlanCampaign({ plan }) {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const content = PLAN_CONTENT[plan] || PLAN_CONTENT.flex;
  const campaign = getIOSHomeCampaigns(theme).find(item => item.id === (plan === "mensalidade" ? "plano-pro" : "plano-flex"));

  return (
    <main className="zuno-app-shell premium-campaign-screen" data-reference-ui="true">
      <header className="premium-campaign-header">
        <button type="button" onClick={() => navigate(-1)} aria-label="Voltar"><LuArrowLeft /></button>
        <span>{campaign?.title || content.name}</span>
      </header>

      <section className="premium-campaign-hero premium-campaign-hero--art">
        <img src={campaign?.image || content.image} alt={campaign?.alt || content.alt} />
      </section>

      <section className="premium-campaign-benefits" aria-labelledby={`${plan}-benefits-title`}>
        <p className="premium-campaign-kicker">{content.kicker}</p>
        <h2 id={`${plan}-benefits-title`}>{content.title}</h2>
        <div>
          {content.benefits.map(([Icon, title, description]) => (
            <article key={title}>
              <Icon />
              <span><strong>{title}</strong><small>{description}</small></span>
            </article>
          ))}
        </div>
        <button className="premium-campaign-back" type="button" onClick={() => navigate("/cadastro-motorista")}>Quero dirigir com a Zuno</button>
        <button className="premium-campaign-back" type="button" onClick={() => navigate("/passenger-home")}>Voltar para a Home</button>
      </section>
    </main>
  );
}
